<template>
  <div>
    <!-- <div>
      <div class="text1">申报书模板下载</div>
      <div class="flex align-items-center">
        <img class="img-box-4" src="../../assets/images/img39.png" alt="" />
        <div class="text2" style="color: #c73630">
          <a
            :href="`${path}思政教育工作室项目申报书.docx`"
            download="思政教育工作室项目申报书.docx"
            style="color: #c73630"
          >
            思政教育工作室项目申报书.docx</a
          >
          <span class="text2">(32.2KB)</span>
        </div>
      </div>
    </div> -->
    <!--1. 下载-->
    <!-- v-if="item.id == 4 || item.id == 6 || item.id == 7" -->
    <div class="mb15" v-for="(item, index) in loadList" :key="index">
      <div class="flex align-items-center mb15">
        <img class="img-box-2" :src="item.icon" alt="" />
        <div class="text1">
          {{ item.title }}
          <span style="color: #f6350f">*</span>
        </div>
      </div>
      <div>
        <a-upload
          :file-list="item.fileList"
          :accept="item.accept"
          :remove="(file, fileList) => handleRemove(file, fileList, index)"
          :customRequest="()=>{return}"
          :before-upload="
            (file, fileList) => beforeUpload(file, fileList, index, item)
          "
        >
          <a-button
            :disabled="
              ($parent.editInfo && $parent.editInfo.type == 'preview') ||
              item.loading
            "
            :loading="item.loading"
          >
            <a-icon type="upload" /> 上传视频
          </a-button>
        </a-upload>
        <!-- <a class="file flex flex-center align-items-center">
          <input
            type="file"
            id="people-export"
            value="shancgahunwenjai "
            @change="onFileChange($event, item)"
          />
          <img class="img-box" src="../../assets/images/img26.png" alt="" />
          上传附件</a
        > -->
        <div class="text2">{{ item.remarks }}</div>
      </div>
    </div>
    <div class="big-box flex">
      <div class="submit-btn btn-bg-1" @click="upStep2">上 一 步</div>
      <div
        class="submit-btn btn-bg-2"
        v-if="$parent.editInfo && $parent.editInfo.type == 'preview'"
        @click="$router.push({ name: 'szStudio' })"
      >
        返回
      </div>
      <div v-else class="submit-btn btn-bg-2" @click="submit">提交</div>
    </div>
    <!-- <div v-else class="submit-btn btn-bg-2" @click="$route.go(-1)">返 回</div> -->

    <!--
     <div class="big-box flex">
      <div class="submit-btn btn-bg-2" @click="submit">提 交</div>
     </div> 
    -->
  </div>
</template>

<script>
import { fileUpdate } from '@/api/index';
export default {
  name: '',
  components: {},
  props: {
    loadList: {
      type: Array,
    },
    oldApplyFiles2: {
      type: Array,
    },
  },
  data() {
    return {
      applyFiles: [],
      path: process.env.BASE_URL,
      loading: false,
      // type4: false,
      // type7: false,
      // type6: false,
      submitLoading: null,
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    handleRemove(file, fileList, fileindex) {
      this.applyFiles = this.applyFiles.filter((item) => {
        if (item.filePath.indexOf(file.name1) === -1) {
          return item;
        }
      });
      const index = this.loadList[fileindex].fileList.indexOf(file);
      this.$emit('deleteFile2', file);
      const newFileList = this.loadList[fileindex].fileList.slice();
      newFileList.splice(index, 1);
      this.loadList[fileindex].fileList = newFileList;
    },
    beforeUpload(file, fileList, fileindex, item) {
      this.$regFile(file, fileList, fileindex, item);
    },
    handleUpload(fileindex, file) {
      this.loadList[fileindex].loading = true;
      const formData = new FormData();
      formData.append('file', file);
      formData.append('biz', 'linxuan');
      fileUpdate(formData).then((res) => {
        if (res.code === 0) {
          this.$message.success(`上传成功`);
          let fileItem = {};
          fileItem.filePath = res.message;
          fileItem.fileType = this.loadList[fileindex].id;
          fileItem.uid = file.uid;
          this.applyFiles.push(fileItem);
          this.$emit('upDataFile', fileItem, fileindex, 2);
          this.loadList[fileindex].loading = false;
        } else {
          this.$message.error('上传失败');
        }
      });
    },
    upStep2() {
      if (this.oldApplyFiles2 && this.oldApplyFiles2.length > 0) {
        this.applyFiles = this.applyFiles.concat(this.oldApplyFiles2);
      }
      this.$emit('upStep2', this.loadList, this.applyFiles);
    },
    submit() {
      this.submitLoading = this.loadList.filter((item) => {
        if (item.loading) {
          return item;
        }
      });
      if (this.submitLoading && this.submitLoading.length >= 1) {
        this.$message.warning('文件正在上传，请上传成功后提交');
      } else {
        // this.loadList.map((item) => {
        //   let newItem = item.fileList.filter((item1) => {
        //     if (item.fileList.length != 0 && item1 && item1.fileType == 4) {
        //       this.type4 = true;
        //     } else if (
        //       item.fileList.length != 0 &&
        //       item1 &&
        //       item1.fileType == 7
        //     ) {
        //       this.type7 = true;
        //     } else if (
        //       item.fileList.length != 0 &&
        //       item1 &&
        //       item1.fileType == 6
        //     ) {
        //       this.type6 = true;
        //     }
        //   });
        //   return newItem;
        // });
        //下面是判断必填代码
        // if (this.type4 && this.type6 && this.type7) {
        if (this.oldApplyFiles2 && this.oldApplyFiles2.length > 0) {
          this.applyFiles = this.applyFiles.concat(this.oldApplyFiles2);
        }
        console.log(this.loadList, this.applyFiles, 'next')
        this.$emit('submit', this.loadList, this.applyFiles);
      }
      // } else {
      //   if (this.type4 === false) {
      //     this.$message.warning("请上传思政教育工作室申报书");
      //   } else if (this.type7 === false) {
      //     this.$message.warning("请上传工作室照片");
      //   }else if (this.type6 === false) {
      //     this.$message.warning("请上传佐证材料");
      //   }
      // }
    },
  },
};
</script>

<style scoped lang="scss">
.text1 {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.mb15 {
  margin-bottom: 15px;
}
.text2 {
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  cursor: pointer;
  color: #999999;
  margin-top: 14px;
  margin-bottom: 15px;
}
.img-box {
  width: 18px;
  height: 18px;
  margin-right: 10px;
}
.img-box-2 {
  width: 19px;
  height: 19px;
  margin-right: 10px;
}
.img-box-4 {
  width: 12px;
  height: 12px;
  margin-right: 10px;
  margin-bottom: 5px;
}
.submit-btn {
  width: 116px;
  height: 40px;
  margin: 0 auto;
  color: #fff;
  background: #9A0B00;
  line-height: 38px;
  text-align: center;
  border-radius: 10px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  cursor: pointer;
}

.big-box {
  width: 253px;
  margin: 0 auto;
}
.file-input-box {
  color: #c73630;
}
.file {
  position: relative;
  width: 156px;
  height: 40px;
  background: #fff;
  border: 1px solid #c73630;
  border-radius: 4px;
  padding: 4px 12px;
  overflow: hidden;
  color: #575757;
  text-decoration: none;
  text-indent: 0;
  line-height: 20px;
  margin-bottom: 15px;
}
.file input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
}
.file:hover {
  background: rgba(218, 218, 218, 0.2);
  color: #000;
  text-decoration: none;
}
</style>
